export function FlowEvidenceNotice() {
  return (
    <section class="flow-evidence-notice">
      <div>
        <span class="signal-mini-kicker">Current evidence</span>
        <strong>
          Current Paths are inferred from page roles, recorded links and Scan
          findings. They are not confirmed customer behaviour.
        </strong>
      </div>
      <p>
        Observed traffic, progression and drop-off evidence will require
        connected GA4 or Adobe Analytics data.
      </p>
    </section>
  );
}
